@if (showRedesignDivider) {
    <ds-divider />
}
<ng-container *msShowInEpcot="false">
    @if (!showPayoutPushErrorHidden) {
        <ng-container *ngTemplateOutlet="cashout" />
    } @else {
        <div class="cashout-error-hidden">
            <p class="cashout-text">{{ payoutPushError?.error?.Title }}</p>
            <p class="cashout-text">{{ payoutPushError?.error?.Message }}</p>
        </div>
    }

    @if (payoutError && payoutErrorMessage) {
        <div class="cashout-error">
            <div class="error-message">
                <vn-icon class="cashout-error-icon" name="theme-error-i" size="13" />
                <span [innerHtml]="payoutErrorMessage"></span>
            </div>
        </div>
    }
</ng-container>
<ng-container *msShowInEpcot="true">
    <ng-container *ngTemplateOutlet="cashout" />
    @if (payoutError && payoutErrorMessage) {
        <div class="epcot-cashout-error">
            <ms-epcot-notification [message]="payoutErrorMessage" [notificationType]="'error'" />
        </div>
    }
</ng-container>
<ng-template #cashout>
    @if (!hideCashoutButton) {
        <div #cashoutContainer class="cashoutContainer" id="cashoutContainer" [ngClass]="{ 'flex-column': betCardRedesigned }">
            <ms-my-bets-earlypayout-button
                [betslip]="betslip"
                [myBetsListContext]="myBetsListContext"
                [payoutPushError]="payoutPushError?.error"
                [betTypeInfo]="betTypeInfo"
                (stateChanged)="onStateChanged()" />
            @if (showEarlyPayoutSettingButton) {
                <div class="cashout-settings" id="cashout-settings">
                    <ms-my-bets-earlypayout-settings
                        [betslip]="betslip"
                        [myBetsListContext]="myBetsListContext"
                        [shouldRefreshPosition]="shouldRefreshPosition"
                        [betTypeInfo]="betTypeInfo"
                        (autoCashoutPopperTriggered)="autoCashoutTriggered($event)" />
                </div>
            }
        </div>
    }
</ng-template>
